var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8064_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.5H6.5M6.5 7.5L4.5 5.5M6.5 7.5L4.5 9.5M0.5 4.5V1.5C0.5 0.947715 0.947715 0.5 1.5 0.5L8.5 0.5C9.05228 0.5 9.5 0.947715 9.5 1.5V14.5C9.5 15.0523 9.05228 15.5 8.5 15.5H1.5C0.947715 15.5 0.5 15.0523 0.5 14.5V10.5M15.5 14.5L15.5 1.5C15.5 0.947715 15.0523 0.5 14.5 0.5L13.5 0.5C12.9477 0.5 12.5 0.947715 12.5 1.5L12.5 14.5C12.5 15.0523 12.9477 15.5 13.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8064_1579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.cbe4091c899044415ade19aac97d98ac.svg";
export { ForwardRef as ReactComponent };